import { alphabeticalCompare } from '@cims-online/shared'
import type { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import ApprovalDetails from '../components/ApprovalDetails'
import { fieldTypeLabel } from '../utils/metadata'
import type { WorkflowField } from '../types'
import { isApprovalsWorkflowField } from '../utils/isApprovalsWorkflowField'

/**
 * Builds the workflow Fields table columns.
 */
export function useColumns(): CIMSColumn<WorkflowField>[] {
  return [
    {
      title: 'Name',
      render: 'name',
      width: 250,
      sort: {
        default: 'ascend',
        with: 'key',
        key: 'name',
      },
      filter: {
        type: 'search',
        with: 'callback',
        onFilter: (value, { name }) =>
          name.toLowerCase().includes(value.toString().toLowerCase()),
      },
    },
    {
      title: 'Description',
      render: 'tooltip',
      width: 350,
      filter: {
        type: 'search',
        with: 'callback',
        onFilter: (value, { tooltip }) =>
          !!tooltip &&
          tooltip.toLowerCase().includes(value.toString().toLowerCase()),
      },
    },
    {
      title: 'Type',
      width: 175,
      render: ({ type }) => fieldTypeLabel(type),
      sort: {
        with: 'callback',
        onCompare: (a, b) =>
          alphabeticalCompare(fieldTypeLabel(a.type), fieldTypeLabel(b.type)),
      },
    },
    {
      title: 'Details',
      width: 400,
      render: (field) =>
        isApprovalsWorkflowField(field) && <ApprovalDetails field={field} />,
    },
  ]
}
